import axios from "axios";
import User from "../User/User";
import ApiException from "./ApiException";

const API_URL = 'https://rekuperace.popovicky.headsoft.cz:8080';

export default class Api {

    constructor() {
        this.interface = axios.create({withCredentials: true, baseURL: API_URL});
        this.user = new User();
        this.user.load();
    }


    controlResponse(response) {
        if (response.status === 200) {
            let data = response.data;
            if (data.errno === 3003) {
                this.logout()
            }
            return response.data;
        } else {
            throw new ApiException(response.errno, response.message, response.responseCode)
        }
    }


    login(user) {
        this.user = user;
        return this.interface.post('acl/login', {user}).then(res=>this.controlResponse(res)).then(
            data => {
                if (data.status === 'ok') {
                    this.user.logged = true;
                    this.user.save();
                    window.location = '/';
                } else {
                    return false;
                }
            }
        )
    }

    logout() {
        this.interface.post('acl/logout').then(() => {
            this.user.logout();
            window.location = '/';
        })
    }

    pergola(action) {
        return this.interface.post('popovicky/pergola', {action: action}).then(res=>this.controlResponse(res));
    }

    rekuperace(action) {
        return this.interface.post('popovicky/rekuperace', {action: action}).then(res=>this.controlResponse(res));
    }

    getTemperature(interval) {
        return this.interface.post('weather/get-temperature-values', {interval: interval}).then(res=>this.controlResponse(res));
    }
    getRekuperaceStatus() {
        return this.interface.post('popovicky/get-rekuperace-status').then(res=>this.controlResponse(res));
    }
    getCurrentWeather() {
        return this.interface.post('weather/get-current-weather').then(res=>this.controlResponse(res));
    }
    getPergolaState() {
        return this.interface.post('popovicky/get-pergola-state').then(res=>this.controlResponse(res));

    }

}
